<template>
  <div
    class="h-[68rem] bg-[url('https://images.rafflebox.ca/RaffleboxLogos/WebsiteAssets/arena-view.jpg')] bg-cover pb-24 lg:h-[70rem] lg:pb-40"
  >
    <div
      class="mx-auto flex max-w-md flex-col-reverse gap-[60px] lg:grid lg:max-w-screen lg:grid-cols-[34%_66%] lg:gap-0"
    >
      <div class="flex flex-col gap-8 px-10 text-center text-white lg:my-auto lg:gap-10 lg:px-3 lg:pt-24 lg:text-left">
        <h1 class="text-[40px] leading-none text-shadow-lg lg:text-6xl">{{ t('HomeHero.title') }}</h1>
        <p class="font-family-display mb-2 text-2xl text-shadow-lg">
          {{ t('HomeHero.subtitle') }}
        </p>
        <Button v-slot="slotProps" as-child size="large">
          <NuxtLink
            :to="localePath({ name: 'contact-us' })"
            :class="[slotProps.class, 'mt-5 min-w-60 no-underline lg:my-2 lg:w-fit']"
          >
            {{ t('HomeHero.cta') }}
            <i class="pi pi-arrow-right pt-1"></i>
          </NuxtLink>
        </Button>
      </div>

      <div class="mx-auto flex max-w-2xl items-center px-3">
        <img
          src="https://images.rafflebox.ca/RaffleboxLogos/WebsiteAssets/RB_JUMBOTRON.png"
          :alt="t('HomeHero.imageAlt')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from 'primevue/button';

const localePath = useLocalePath();
const { t } = useI18n();
</script>
